import * as React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <React.Fragment>
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="6" fill="white" />
      <path
        d="M5.83301 13.1666C5.83301 13.1666 9.04134 16.8333 14.9997 16.8333C20.958 16.8333 24.1663 13.1666 24.1663 13.1666"
        stroke="black"
        stroke-width="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.66634 14.6741L5.83301 16.8333"
        stroke="black"
        stroke-width="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1667 16.8334L22.3369 14.6777"
        stroke="black"
        stroke-width="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1709 16.5397L11.333 19.1249"
        stroke="black"
        stroke-width="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8076 16.5469L18.667 19.125"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </React.Fragment>,
  'Eye Closed'
)
